import "../css/index";
import YoutubeApp from "./YoutubeApp";

new YoutubeApp();
